import { FunctionComponent, useEffect, useState, useContext, useRef } from "react";
import {
  Container,
  TextField,
  Button,
  Grid,
  Typography,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  MenuItem,
  TablePagination,
  Card,
  CardContent,
  CircularProgress,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import { useFormik, FormikProvider, Form } from "formik";
import * as Yup from "yup";
import SessionStorageService from "../../../services/StorageService";
import { useNavigate } from "react-router-dom";
import AboneSicilListeAPI from "../../../apis/OB/Get/AboneSicilListeAPI";
import AbonelerAPI from "../../../apis/OB/Get/AbonelerAPI";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import { displayValue, year } from "../../../helpers/TodayDate";
import { changeDateFormat } from "../../../helpers/DateFormat";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import FaturaItirazSave, { ItirazBasvuruSaveRequest } from "../../../apis/OB/SaveApi/FaturaItirazSave";
import AboneFaturaItirazListe from "../../../apis/OB/Get/AboneFaturaItirazListe";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import Recaptcha from "../../../components/Recaptcha";
import { toast } from "react-toastify";
import DysAPI from "../../../apis/DysAPI";

const FaturaItiraz: FunctionComponent = () => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  const { yilListe } = useContext(ConstantAPISContext);
  const [aboneData, setAboneData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [faturaData, setFaturaData] = useState<any[]>([]);
  const [checkedIndex, setCheckedIndex] = useState<number | null>(null);
  const [checkedIndexFatura, setCheckedIndexFatura] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [selectedYear, setSelectedYear] = useState(Number(year));
  const [popupContent, setPopupContent] = useState<string>("");
  const [isLoad, setIsLoad] = useState<boolean>(true);
  const [aktifAboneVarMi, setAktifAboneVarMi] = useState<boolean>(false);

  const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
  const [aciklamaPopUpVisible, setAciklamaPopUpVisible] = useState<boolean>(false);
  const [kayitBasarili, setKayitBasarili] = useState<boolean>(false);
  const navigate = useNavigate();
  let user = SessionStorageService.getUserInfo();
  const [userControlPopup, setUserControlPopup] = useState<boolean>(false);
  const [activeStep, setActiveStep] = useState(0);

  const steps = ['Abone Bilgileri', 'Fatura Bilgileri', 'Evrak Yükleme'];

  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  };

  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };

  useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: -5 })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });


        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);

  useEffect(() => {
    if (!user) {
      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }
  }, [user]);

  const closePopup = () => {
    setIsPopupVisible(false);
    setAciklamaPopUpVisible(false);
    if (aktifAboneVarMi === false) {
      navigate(-1)
    }
  };

  const openPopup = (content: string) => {
    setPopupContent(content);
    setAciklamaPopUpVisible(true);
  };

  const fetchData = () => {
    if (formik.values.aboneNo !== undefined && !isNaN(formik.values.aboneNo) && user) {
      setIsLoading(true);
      AboneSicilListeAPI.getAboneSicilListe(
        user?.sicilKodu,
        formik.values.aboneNo === -1 ? undefined : formik.values.aboneNo
      )
        .then((res) => {
          if (res.data.length > 0) {
            setData(res.data);
          } else {
            openPopup(
              "Sayaçınız henüz oluşturulmamıştır. Sayaç kayıtları girildikten sonra devam edebilirsiniz."
            );
          }
        })
        .catch((err) => {
          console.error("Abone Sicil Liste API hatası:", err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (user) {
      setIsLoading(true);
      AboneSicilListeAPI.getAboneSicilListe(
        user?.sicilKodu,
        formik.values.aboneNo === -1 ? undefined : formik.values.aboneNo
      )
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => {
          console.error("Abone Sicil Liste API hatası:", err);
        });

      AbonelerAPI.getAbonelerListe(2,user?.sicilKodu)
        .then((res) => {
          if (res.data.length > 0) {
            setAktifAboneVarMi(true)
            setAboneData(res.data)
          } else {
            openPopup("Aktif bir aboneliğiniz bulunmadığı için bu sayfa da işlem yapamazsınız.");

          }
        })
        .catch((err) => {
          console.error("Aboneler Liste API hatası:", err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  const clearAllInputs = () => {
    formik.resetForm();
    setCheckedIndex(null);
    setCheckedIndexFatura(null);
    fetchData();
  };

  const formik = useFormik({
    initialValues: {
      aboneNo: -1,
      aciklama: "",
    },
    validateOnMount: true,
    validationSchema: Yup.object({
      aboneNo: Yup.number().required("Abone numarası seçiniz"),
      aciklama: Yup.string().required("Açıklama giriniz"),
    }),

    onSubmit: async (values) => {
      const missingDocuments = documents
        .filter(doc => doc.isRequired) // zorunlu belgeler
        .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

      if (missingDocuments.length > 0) {
        const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
        toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
        documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
        return; // başvuru burada durur
      }

      if (checkedIndexFatura === null) {
        openPopup("Lütfen bir fatura seçiniz.");
        return;
      }
      // reCAPTCHA’yı tetikle
      const token = await recaptchaRef.current?.handleSubmit();
      if (!token) {
        toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
        return;
      }
      const request = new ItirazBasvuruSaveRequest(
        304,
        checkedIndexFatura,
        values.aciklama,
        token
      );

      // Fatura işlemleri için gerekli kodlar
      if (checkedIndexFatura === null) {
        openPopup("Lütfen bir fatura seçiniz.");
        return;
      }
      setLoadingSubmit(true);
      try {
        const res = await FaturaItirazSave.saveItirazBasvuruSave(request);
        if (res.data.sonuc === 0) {
          let basvuruNo = res.data.basvuruNo;

          // DYS API'yi çağır 
          try {
            // Sadece dosyası olanları al
            const filesToSend = documents.filter((doc: any) => !!doc.file);

            if (filesToSend.length > 0) {
              const formData = new FormData();

              filesToSend.forEach((doc: any) => {
                formData.append("files", doc.file, doc.file.name);
                formData.append("rfObBasvuruTanimBelge", String(doc.id));
              });

              formData.append("basvuruTuru", String(-5 || 0));
              formData.append("basvuruId", String(basvuruNo));
              formData.append("folderName", "AKOS");
              formData.append("kurumId", "1");
              formData.append("versionable", "1");

              const response = await DysAPI.upload(formData);
              toast.warning(response.message);
            } else {
              // Burada return yok — sadece DYS çağrısını atlıyoruz.
              
            }
          } catch (error: any) {
            toast.error("DYS upload hazırlama hatası:", error);
          }

          setPopupContent(
            "İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " +
            basvuruNo
          );
          setKayitBasarili(true);
          // Başarılı işlemden sonra formu ve adımları resetleme
          formik.resetForm();
          setDocuments((prevDocs: any[]) =>
            prevDocs.map((doc) => ({
              ...doc,
              file: null,
              fileName: "",
            }))
          );
          setActiveStep(0);
          setCheckedIndex(null);
          setCheckedIndexFatura(null);
        } else {
          setPopupContent(res.data.sonucAciklama);
        }
      } catch (err) {
        setPopupContent(
          "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
        );
      } finally {
        setIsPopupVisible(true);
        recaptchaRef.current?.reset();
        setLoadingSubmit(false);
      }
    },
  });

  const fetchFaturaData = async () => {
    if (formik.values.aboneNo) {
      setIsLoading(true);
      try {
        const res = await AboneFaturaItirazListe.getAboneFaturaItirazListe(
          selectedYear,
          checkedIndex!,
          user?.sicilKodu
        );
        setFaturaData(res.data);
      } catch (err) {
        console.error("Abone Fatura Itiraz Liste API hatası:", err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (formik.values.aboneNo && checkedIndex) {
      fetchFaturaData();
    }
  }, [formik.values.aboneNo, selectedYear]);

  const handleNext = () => {
    if (activeStep === 1) {
      formik.validateField('aciklama').then(() => {
        if (checkedIndexFatura !== null && !formik.errors.aciklama) {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else if (formik.errors.aciklama) {
          openPopup("Lütfen açıklama alanını doldurun.");
        } else {
          openPopup("Lütfen bir fatura seçiniz.");
        }
      });
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={8}>
                <TextField
                  size="small"
                  select
                  fullWidth
                  label="Abone No"
                  value={formik.values.aboneNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="aboneNo"
                  error={formik.touched.aboneNo && Boolean(formik.errors.aboneNo)}
                  helperText={formik.touched.aboneNo && formik.errors.aboneNo}
                >
                  <MenuItem value={-1}>Abone No</MenuItem>
                  {aboneData.map((item, index) => (
                    <MenuItem key={index} value={item.aboneNo}>
                      {item.aboneNo}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
                container
                spacing={2}
                justifyContent="flex-end"
              >
                <Grid item>
                  <Button variant="contained" onClick={fetchData}>
                    Ara
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" onClick={clearAllInputs}>
                    Temizle
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {isLoading ? (
                  <Typography>Loading...</Typography>
                ) : (
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Abone No</TableCell>
                          <TableCell>Abone Tipi</TableCell>
                          <TableCell>Sayaç Markası</TableCell>
                          <TableCell>Sayaç No</TableCell>
                          <TableCell>Adres</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data
                          .slice(
                            currentPage * rowsPerPage,
                            currentPage * rowsPerPage + rowsPerPage
                          )
                          .map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <Checkbox
                                  checked={checkedIndex === Number(item.aboneNo)}
                                  onChange={() => {
                                    if (checkedIndex === Number(item.aboneNo)) {
                                      setCheckedIndex(null);
                                    } else {
                                      setCheckedIndex(Number(item.aboneNo));
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell>{item.aboneNo}</TableCell>
                              <TableCell>{item.aboneTipi}</TableCell>
                              <TableCell>{displayValue(item.sayacMarkası)}</TableCell>
                              <TableCell>{item.sayacNo}</TableCell>
                              <TableCell>{item.adres}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[4, 10, 25]}
                      component="div"
                      count={data.length}
                      rowsPerPage={rowsPerPage}
                      page={currentPage}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                )}
              </Grid>
            </Grid>
            <div className="d-flex w-100 justify-content-end mt-3">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  if (checkedIndex !== null) {
                    handleNext();
                  } else {
                    openPopup("Lütfen bir abone seçiniz.");
                  }
                }}
              >
                İleri
              </Button>
            </div>
          </>
        );
      case 1:
        return (
          <>
            <h6 className="mb-3">Lütfen Tabloda arama yapıp faturanızı seçiniz!</h6>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={8}>
                <TextField
                  size="small"
                  select
                  fullWidth
                  label="Yıl"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(Number(e.target.value))}
                >
                  {yilListe.map((item: any, index: any) => (
                    <MenuItem key={index} value={item.yili}>
                      {item.yili}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
                container
                spacing={2}
                justifyContent="flex-end"
              >
                <Grid item>
                  <Button variant="contained" onClick={fetchFaturaData}>
                    Ara
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" onClick={clearAllInputs}>
                    Temizle
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {isLoading ? (
                  <Typography>Loading...</Typography>
                ) : (
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Yıl</TableCell>
                          <TableCell>Dönem</TableCell>
                          <TableCell>Okuma Durumu</TableCell>
                          <TableCell>İlk Endeks</TableCell>
                          <TableCell>Son Endeks</TableCell>
                          <TableCell>Ortalama</TableCell>
                          <TableCell>Toplam Sarfiyat</TableCell>
                          <TableCell>Okuma Tarihi</TableCell>
                          <TableCell>Fatura Tarihi</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {faturaData.length > 0 ? faturaData
                          .slice(
                            currentPage * rowsPerPage,
                            currentPage * rowsPerPage + rowsPerPage
                          )
                          .map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <Checkbox
                                  checked={checkedIndexFatura === Number(item.faturaSqId)}
                                  onChange={() => {
                                    if (checkedIndexFatura === Number(item.faturaSqId)) {
                                      setCheckedIndexFatura(null);
                                    } else {
                                      setCheckedIndexFatura(Number(item.faturaSqId));
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell>{displayValue(item.yili)}</TableCell>
                              <TableCell>{displayValue(item.donem)}</TableCell>
                              <TableCell>{displayValue(item.okumaDurumu)}</TableCell>
                              <TableCell>{displayValue(item.ilkEndeks)}</TableCell>
                              <TableCell>{displayValue(item.sonEndeks)}</TableCell>
                              <TableCell>{displayValue(item.ortalama)}</TableCell>
                              <TableCell>{displayValue(item.toplamSarfiyat)}</TableCell>
                              <TableCell>
                                {displayValue(item.faturaTarihi)}
                              </TableCell>
                              <TableCell>{displayValue(item.faturaToplami)}</TableCell>
                            </TableRow>
                          )) : <TableRow><TableCell>Kayıt bulunamadı!</TableCell></TableRow>}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[4, 10, 25]}
                      component="div"
                      count={faturaData.length}
                      rowsPerPage={rowsPerPage}
                      page={currentPage}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  label="Açıklama"
                  value={formik.values.aciklama}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="aciklama"
                  error={formik.touched.aciklama && Boolean(formik.errors.aciklama)}
                  helperText={formik.touched.aciklama && formik.errors.aciklama}
                  multiline
                  rows={4}
                />
              </Grid>
            </Grid>
            <div className="d-flex w-100 justify-content-between mt-3">
              <Button variant="contained" onClick={handleBack}>
                Geri
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  formik.validateField('aciklama').then(() => {
                    if (checkedIndexFatura !== null && !formik.errors.aciklama) {
                      handleNext();
                    } else if (formik.errors.aciklama) {
                      openPopup("Lütfen açıklama alanını doldurun.");
                    } else {
                      openPopup("Lütfen bir fatura seçiniz.");
                    }
                  });
                }}
              >
                İleri
              </Button>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <Typography variant="h6">Evrak Yükleme Adımı</Typography>
            <div ref={documentTableRef}>
              {!docsLoaded ? (
                <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
              ) : (
                <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
              )}
            </div>
            <div className="d-flex w-100 justify-content-between mt-3">
              <Recaptcha
                ref={recaptchaRef}
                changeHandleRecaptcha={setRecaptchaPassed}
              />
              <Button variant="contained" onClick={handleBack}>
                Geri
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => formik.handleSubmit()}
              >
                Yükle ve Gönder
              </Button>
              {loadingSubmit && (
                <div
                  style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(255,255,255,0.6)",
                    zIndex: 1300,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress />
                </div>
              )}
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return isLoad ? (
    <>
      <div className="d-flex align-self-stretch justify-content-center align-items-center">
        <CircularProgress />
      </div>
      {userControlPopup && (
        <AciklamaAndUserControlPopup
          open={userControlPopup}
          handleClose={closeUserControlPopup}
          isUserControlPopUp={true}
          description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
        />
      )}
    </>
  ) : (

    <>
      <Card >
        <CardContent>
          <FormikProvider value={formik}>
            <Form>
              <Stepper className="mb-4" activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              {renderStepContent(activeStep)}
            </Form>
          </FormikProvider>
        </CardContent>
      </Card>
      {isPopupVisible && (
        <BilgilendirmePopup
          basvuruTuruId={-5}
          isSorunBildirPopup={!kayitBasarili}
          closePopup={closePopup}
          open={isPopupVisible}
          editDescription={popupContent}
        />
      )}
      {aciklamaPopUpVisible && (
        <AciklamaAndUserControlPopup
          open={aciklamaPopUpVisible}
          handleClose={closePopup}
          isUserControlPopUp={false}
          description={popupContent}
        />
      )}
    </>

  );
};

export default FaturaItiraz;
